/**
 * BIC (Bank Identifier Code)
 *
 * @see https://www.iban.de/bic.html
 */
export class Bic {
  private _value: string;

  constructor(bic: string) {
    this._value = bic;
  }

  /**
   * The complete value
   */
  public get value() {
    return this._value;
  }

  /**
   * The bank code
   */
  public get bankCode() {
    return this._value.substring(0, 4);
  }

  /**
   * The country code
   */
  public get countryCode() {
    return this._value.substring(4, 6);
  }

  /**
   * The location code
   */
  public get locationCode() {
    return this._value.substring(6, 8);
  }

  /**
   * The branch code
   */
  public get bankBranchCode() {
    return this._value.substring(8);
  }
}
